import { render, staticRenderFns } from "./receiveableLimitAdd.vue?vue&type=template&id=4814ef25&scoped=true&"
import script from "./receiveableLimitAdd.vue?vue&type=script&lang=js&"
export * from "./receiveableLimitAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4814ef25",
  null
  
)

export default component.exports